import React, { Component } from 'react'
import { hasLength, noop } from 'shared/helpers/functional'

import 'less/controls/icon-dropdown.less'

const OptionComponent = ({action, display}) => (
  <div className='option' onClick={action}>
    {display}
  </div>
)

class IconDropdown extends Component {
  state = {
    showMenu: false,
  }

  toggleDropdown = () => this.setState({showMenu: !this.state.showMenu})

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    if(this.state.showMenu && this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({showMenu: false})
    }
  }

  render() {
    const isDisabled = !hasLength(this.props.options)
    
    return (
      <div
        className={`icon-dropdown-container ${isDisabled ? 'disabled' : ''}`}
        onClick={isDisabled ? noop : this.toggleDropdown}
        ref={div => {
          this.wrapperRef = div
        }}
      >
        {!this.props.hideIcon && <i className={this.props.iconClassName || 'im-ss-target'} />}
        <div className="icon-dropdown-description-wrapper">
          <p className="icon-dropdown-description">{this.props.description || ''}</p>
          { this.state.showMenu &&
            !isDisabled &&
              <div className= {(this.props.customClassName==='' || !this.props.customClassName)? 'menu' : this.props.customClassName} >
              {this.props.options.map((option, i) =>
                <OptionComponent action={option.action} display={option.display} key={i} />
              )}
            </div>
          }
        </div>
      </div>
    )
  }
}

export default IconDropdown
